import {IUser} from 'src/app/models/auth/user.interface';
import {Component, OnInit, ViewChild} from '@angular/core';
import {CivilStateEnum} from '../../models/patient';
import {GenderEnum} from '../../models/user';
import {MessageAlertService} from '../../services/message-alert/message-alert.service';
import {fadeInAnimation} from '../../animations/fade-in.animation';
import {UtilitiesService} from '../../services/utilities-service/utilities.service';
import {IUserRegisterInformation} from '../../interfaces/record';
import {NgForm} from '@angular/forms';
import {StorageService} from '../../services/storage/storage.service';
import {PLATFORM_CONFIG} from '../../config/platform.config';

@Component({
  selector: 'app-user-register-information',
  templateUrl: './user-register-information.component.html',
  styleUrls: ['./user-register-information.component.scss'],
  animations: [fadeInAnimation]
})
export class UserRegisterInformationComponent implements OnInit {
  @ViewChild('form') form: NgForm;
  genderEnum = GenderEnum;
  civilStateOptions: string[] = [];
  imageProfile: File;
  url;
  birthday: Date;
  dragEnter: boolean;
  isValidate: boolean;
  gender: GenderEnum;

  platformConfig = PLATFORM_CONFIG;

  constructor(
    public alertService: MessageAlertService,
    public utilityService: UtilitiesService,
    private storageService: StorageService,
  ) { }

  ngOnInit(): void {
    this.initValues().then();
  }

  /**
   * Inicializa las propiedades necesarias
   */
  async initValues(): Promise<void> {
    this.civilStateOptions = [
      CivilStateEnum.MARRIED,
      CivilStateEnum.SINGLE,
      CivilStateEnum.IN_RELATIONSHIP,
      CivilStateEnum.DIVORCEE,
      CivilStateEnum.WINDOWED
    ];
    const userLogged: IUser = this.storageService.getLocalItem<{ user: IUser, token: string }>('user')?.user;
    console.log('data unregistered', userLogged);
    if (userLogged) {
      this.birthday = userLogged.birthday;
      this.gender = userLogged.gender;
    }
  }

  onSelectImageProfile(files: FileList): void {
    const fileInput = files.item(0);
    if (!fileInput) {
      return;
    }
    const reader = new FileReader();
    reader.onload = (evt: ProgressEvent<FileReader>) => {
      if (this.utilityService.validateExtensionImage(fileInput as File)) {
        this.imageProfile = fileInput as File;
        this.url = evt.target.result;
        this.dragEnter = false;
      }
    };
    reader.onerror = (event: ProgressEvent<FileReader>) => {
      const errMsg = 'El archivo no se puede leer: ' + event.target.error.code;
      this.alertService.createMessage('error', errMsg);
    };
    reader.readAsDataURL(fileInput);
  }

  onDropImageProfile(ev: DragEvent): void {
    ev.preventDefault();
    if (ev.dataTransfer.files[0] && this.utilityService.validateExtensionImage(ev.dataTransfer.files[0])) {
      this.imageProfile = ev.dataTransfer.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(this.imageProfile);
      reader.onloadend = (event: ProgressEvent<FileReader>) => {
        this.url = event.target.result;
        this.dragEnter = false;
      };
      reader.onerror = (evt: ProgressEvent<FileReader>) => {
        const errMsg = 'El archivo no se puede leer: ' + evt.target.error.code;
        this.alertService.createMessage('error', errMsg);
      };
    }
  }

  onDragEnter(): void {
    this.dragEnter = true;
  }

  onDragLeave(): void {
    this.dragEnter = false;
  }

  allowDrop(ev): void {
    ev.preventDefault();
  }

  public validate(): boolean {
    this.isValidate = true;
    this.form.control.markAllAsTouched();
    this.form.control.markAsDirty();
    if (!this.form.valid) {
      this.alertService.createMessage('error', 'Debes completar los datos para seguir');
    }
    return this.form.valid;
  }

  public getValue(): IUserRegisterInformation {
    return {
      image: this.imageProfile,
      birthday: this.birthday,
      gender: this.gender
    };
  }
}
